<div *ngIf="hero">
  <h2>{{ hero.name | uppercase }} Details</h2>
  <div><span>id: </span>{{ hero.id }}</div>
  <div>
    <label>name: </label>
    <input [(ngModel)]="hero.name" placeholder="name" />
  </div>
</div>
<button (click)="goBack()">go back</button>
<button (click)="save()">save</button>

<h2>{{ curpath }}</h2>
